import { render, staticRenderFns } from "./NewiqcUserUpload.vue?vue&type=template&id=beaf29c6&scoped=true"
import script from "./NewiqcUserUpload.vue?vue&type=script&lang=js"
export * from "./NewiqcUserUpload.vue?vue&type=script&lang=js"
import style0 from "./NewiqcUserUpload.vue?vue&type=style&index=0&id=beaf29c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaf29c6",
  null
  
)

export default component.exports